var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ms-cell-example"},[_c('h2',[_vm._v("cell")]),_c('ms-cell',{attrs:{"is-link":""},nativeOn:{"click":function($event){return _vm.handleListClick($event)}}}),_c('ms-cell',{attrs:{"is-link":""},nativeOn:{"click":function($event){return _vm.handleListClick($event)}}},[_vm._v("test2asdfasfa asfasfasfasfasdfasdfasdsasgasg")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3484ed86","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cell.vue
// module id = null
// module chunks = 